import ApiService from '@/common/api.service'
import * as action from '@/store/action.types'
import {
  GET_PAY_REPORTS_PDF_URL,
  GET_PAY_REPORTS_EXCEL_URL,
  GET_MSG_REPORTS_PDF_URL,
  GET_MSG_REPORTS_EXCEL_URL
} from '@/constants/ApiConstants'

const actions = {
  [action.GET_PAY_REPORTS_PDF](_, data) {
    return ApiService.post(GET_PAY_REPORTS_PDF_URL, data);
  },
  [action.GET_PAY_REPORTS_EXCEL](_, data) {
    return ApiService.post(GET_PAY_REPORTS_EXCEL_URL, data);
  },
  [action.GET_MSG_REPORTS_PDF](_, data) {
    return ApiService.post(GET_MSG_REPORTS_PDF_URL, data);
  },
  [action.GET_MSG_REPORTS_EXCEL](_, data) {
    return ApiService.post(GET_MSG_REPORTS_EXCEL_URL, data);
  }
}

export default {
  actions
}